import { Component, inject } from '@angular/core';
import { DepletionTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DepletionTypeCreateDto,
  DepletionTypeDto,
  DepletionTypeExcelDownloadDto,
  DepletionTypeUpdateDto,
} from '../proxy/controlling/dtos/depletion-type';
import { DEPLETIONTYPE_CONFIG, DEPLETIONTYPE_FIELDS } from './depletion-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-depletion-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DepletionTypeService, ConfirmationService],
  templateUrl: './depletion-type.html',
  styleUrl: './depletion-type.scss',
})
export class DepletionType extends BaseCrudComponent<
  DepletionTypeDto,
  DepletionTypeCreateDto,
  DepletionTypeUpdateDto,
  DepletionTypeExcelDownloadDto
> {
  service = inject(DepletionTypeService);
  config = DEPLETIONTYPE_CONFIG;
  fields = DEPLETIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: DepletionTypeDto): DepletionTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DepletionType';
  }
}
